import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Spacing } from '@reservamos/elements';
import SearchBar from 'components/search/SearchBar';
import MobileSearchTrigger from './MobileSearchTrigger';

/**
 * Search modal component
 * @param {Object} props - Component props
 * @param {Object} props.history - History object
 * @param {string} props.title - Title of the modal
 * @returns
 */
const SearchModal = ({ history, title }) => {
  return (
    <Modal
      modalTrigger={<MobileSearchTrigger />}
      title={title}
      showOverFlowContent
      hasBlushing
      responsiveSize="L"
    >
      <Spacing justifyContent="center" alignItems="center">
        <SearchBar isModalVersion history={history} />
      </Spacing>
    </Modal>
  );
};

SearchModal.propTypes = {
  history: PropTypes.object.isRequired,
  title: PropTypes.string,
};

SearchModal.defaultProps = {
  title: '',
};

export default SearchModal;
